import { ProcessVariable } from "event-definitions"
import { REMOVE_VARIABLE } from "lib/graphql/api"

export class InitialValue {
    constructor(value) {
        this.value = value
    }
}

export function withInitialValue(value) {
    return new InitialValue(value)
}

ProcessVariable.handleOnce(({ variable }) => {
    if (variable instanceof InitialValue) {
        return { initialValue: variable.value, variable: REMOVE_VARIABLE }
    }
    return undefined
})
